import React, { useState } from 'react';
import './Products.css';

const ShareProduct = ({ product, onClose }) => {
  const [copied, setCopied] = useState(false);
  const productUrl = `${window.location.origin}/producto/${product.id}`;

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Error al copiar al portapapeles:', err);
    }
  };

  const shareToWhatsApp = () => {
    const text = `Mira este producto: ${product.model} - ${productUrl}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
  };

  const shareToFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(productUrl)}`;
    window.open(url, '_blank');
  };

  const shareToEmail = () => {
    const subject = `Mira este producto: ${product.model}`;
    const body = `Hola,\n\nTe comparto este producto que encontré:\n\n${product.model}\nPrecio: $${product.price}\n\nPuedes verlo aquí: ${productUrl}`;
    const url = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(url);
  };

  return (
    <div className="modal-overlay-container" onClick={onClose}>
      <div className="modal-content-container" onClick={(e) => e.stopPropagation()}>
        <div className="product-share-modal">
          <div className="product-share-modal-header">
            <h3>Compartir Producto</h3>
            <button onClick={onClose} className="product-share-close-button">×</button>
          </div>
          
          <div className="product-share-product-info">
            <img src={product.images ? product.images[0] : ''} alt={product.model} />
            <div>
              <h4>{product.model}</h4>
              <p>${product.price}</p>
            </div>
          </div>

          <div className="product-share-options">
            <button 
              className="product-share-option-button product-share-whatsapp"
              onClick={shareToWhatsApp}
            >
              📱 WhatsApp
            </button>
            
            <button 
              className="product-share-option-button product-share-facebook"
              onClick={shareToFacebook}
            >
              📘 Facebook
            </button>
            

            
            <button 
              className="product-share-option-button product-share-email"
              onClick={shareToEmail}
            >
              📧 Email
            </button>
          </div>

          <div className="product-share-link-section">
            <label>Enlace directo:</label>
            <div className="product-share-link-input-container">
              <input 
                type="text" 
                value={productUrl} 
                readOnly 
                className="product-share-link-input"
              />
              <button 
                className="product-share-copy-link-button"
                onClick={() => copyToClipboard(productUrl)}
              >
                {copied ? '✓ Copiado' : '📋 Copiar'}
              </button>
            </div>
          </div>

          <div className="product-share-modal-footer">
            <button onClick={onClose} className="product-share-cancel-button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareProduct; 